/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const brandActions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class brandStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
				useStore: false,
				storeData:{
					p:1,
					s:10,
					name:'',
					code:'',
					active:''
				}
		}
		this.listenables = brandActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/productBrand/store.js